import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    tarjetaId: 0,
    banco: '',
    tarjetaMarca: '',
    numeroCuenta: '',
    
    fechaCierre: moment.utc(new Date()).format('YYYY-MM-DD'),
    fechaVencimiento: moment.utc(new Date()).format('YYYY-MM-DD'),

    tarjetaResumenDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_TARJETA_RESUMEN' (state, tarjetaId) {
        state.tarjetaId= tarjetaId;
        state.banco = '';
        state.tarjetaMarca = '';
        state.numeroCuenta = '';

        state.fechaCierre = moment.utc(new Date()).format('YYYY-MM-DD');
        state.fechaVencimiento = moment.utc(new Date()).format('YYYY-MM-DD');
    },
    'SET_TARJETA' (state, tarjeta) {
        state.banco = tarjeta.banco;
        state.tarjetaMarca = tarjeta.tarjetaMarca;
        state.numeroCuenta = tarjeta.numeroCuenta;
    },

    'INICIALIZAR_DATOS' (state) {
        state.tarjetaResumenDatos = [];
    },
    'SET_DATOS' (state, params) {
        state.tarjetaResumenDatos = params.tarjetaResumenDatos;
    },
};


const getters = {
    getField,

    tarjetaResumenDatos (state) {
        return state.tarjetaResumenDatos;
    },
};

const actions = {
    inicializar ( { commit }, tarjetaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETA_RESUMEN', tarjetaId);

            if (tarjetaId != 0) {
                apiAxios.get('tarjetas/' + tarjetaId ) 
                .then(res => {
                    commit('SET_TARJETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                let tarjetaResumen= {
                    tarjetaId: parseInt(state.tarjetaId),
                    fechaCierre: moment.utc(state.fechaCierre).format('YYYY-MM-DD'),
                    fechaVencimiento: moment.utc(state.fechaVencimiento).format('YYYY-MM-DD'),
                };

                apiAxios.post('tarjetasresumenes', tarjetaResumen)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },

    getDatos ( { commit }, tarjetaResumenId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (tarjetaResumenId) {
                apiAxios.get('tarjetasresumenes/' + tarjetaResumenId ) 
                    .then(res => {
                        let tarjetaResumenDatos = [
                            { 'nombre': 'banco', 'campo': 'Banco', 'valor': res.data.banco, 'formato': '' },
                            { 'nombre': 'tarjetaMarca', 'campo': 'Tarjeta', 'valor': res.data.tarjetaMarca, 'formato': '' },
                            { 'nombre': 'numeroCuenta', 'campo': 'Nro Cuenta', 'valor': res.data.numeroCuenta, 'formato': '' },
                            { 'nombre': 'fechaCierre', 'campo': 'Fecha de Cierre', 'valor': res.data.fechaCierre, 'formato': 'fecha' },
                            { 'nombre': 'fechaVencimiento', 'campo': 'Fecha de Vencimiento', 'valor': res.data.fechaVencimiento, 'formato': 'fecha' }
                        ]

                        let params = {
                            tarjetaResumenDatos,
                        }
                                      
                        commit('SET_DATOS', params);
                        resolve();
                    })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}